import React, { Component } from "react";
import { Switch, Route, Redirect, BrowserRouter } from "react-router-dom";
import CommonRoute from './views/common/protectRoutes/protectRoute';
import VerifyRegister from './views/common/protectRoutes/verifyRegister';
import Agreement from './views/common/Model/agreement';
import Login from "./views/common/login";
import Register from './views/common/register';
import ChangePassword from './views/common/changePassword';
import ForgotPassword from './views/common/forgotPassword';
import PatientReg from './views/patient/register';
import FacilityReg from './views/facility/Registration/register';
import FinalFacilityReg from './views/facility/Registration/finalRegistration';
import OtherReg from './views/otherRequestor/otherReg';
import ViewProfile from './views/common/viewProfile';
import PatientHome from './views/patient/home';
import PatientRequest from './views/patient/request';
import PatientNewRequest from './views/patient/newRequest';
import PatientRecord from './views/patient/record';
import FinalRequest from './views/patient/finalRequest';
import PatientPayment from './views/patient/payment/payment';
import RequestStatus from './views/patient/requestStatus';
import Paymentpage from './views/patient/payment/fullPayment';
import FacilityHome from './views/facility/home';
import Practitioners from './views/facility/Practitioner/practitioners';
import FacilityEmr from './views/facility/emrOrVpn/emrOrVpn';
import AdminHome from './views/admin/home';
import PaymentRules from './views/admin/paymentRules';
 import EmployeHome from './views/employee/home';
import RandomPin from './views/common/randomPin';
import CreateNewPassword from './views/common//newPassword';
import Settings from "./views/common/settings";
import Contact from "./views/common/contact";
import EditPaymentRules from "./views/admin/editPaymentRules";
import FaqPage from './views/common/faq';
import PrivacyPage from './views/common/privacyTerms';
import PageNotFound from './components/pageNotFound'
import EnableAccount from './views/patient/enableAccount';
import resendVerificatonLink from './views/common/resendVerificationLink';



class EpaparRoad extends Component { 
  render() { 
    return (
      <BrowserRouter>
        <Switch>
          <Redirect exact state={  "noo"} path="/" to={"/login"} />
          {/* <AdminRoute path="/protected" component={Protected} /> */}
           <Route exact path={"/login"} component={Login} />
           <Route exact path={"/ForgotPassword"} component={ForgotPassword} />
           <Route exact path={"/resendVerificatonLink"} component={resendVerificatonLink} />
           <Route exact path={"/Register"} component={Register} />
           <Route exact path={"/Agreement"} component={Agreement} />
           <Route exact path={"/PatientReg"} component={PatientReg} />
           <Route exact path={"/FacilityReg"} component={FacilityReg} />
           <Route exact path={"/FinalFacilityReg"} component={FinalFacilityReg} />
           <Route exact path={"/OtherReg"} component={OtherReg} />
           <Route  exact  path={"/Contact"} component={Contact} />
           <Route  route="common"   path={"/FaqPage"} component={FaqPage} />
           <Route exact path={"/PrivacyPage"} component={PrivacyPage} />

           <Route exact path={"/verifyRegister/:email"} component={VerifyRegister} />
           <CommonRoute  route="common"   path={"/ChangePassword"} component={ChangePassword} />
           <CommonRoute  route="common"   path={"/ViewProfile"} component={ViewProfile} /> 
           <CommonRoute  route="patient"   path={"/PatientHome"} component={PatientHome} /> 
           <CommonRoute  route="patient"   path={"/PatientRequest"} component={PatientRequest} /> 
           <CommonRoute  route="patient"   path={"/PatientNewRequest"} component={PatientNewRequest} /> 
           <CommonRoute  route="patient"   path={"/PatientRecord"} component={PatientRecord} /> 
           <CommonRoute  route="patient"   path={"/FinalRequest"} component={FinalRequest} /> 
           <CommonRoute  route="patient"   path={"/PatientPayment"} component={PatientPayment} /> 
           <CommonRoute  route="patient"   path={"/RequestStatus"} component={RequestStatus} /> 
           <CommonRoute  route="facility"   path={"/FacilityHome"} component={FacilityHome} /> 
           <CommonRoute  route="facility"   path={"/FacilityEmr"} component={FacilityEmr} /> 
           <CommonRoute  route="facility"   path={"/Practitioners"} component={Practitioners} />
           <CommonRoute  route="admin"   path={"/AdminHome"} component={AdminHome} /> 
           <CommonRoute  route="admin"   path={"/PaymentRules"} component={PaymentRules} /> 
            <CommonRoute  route="employee"   path={"/EmployeHome"} component={EmployeHome} />
           <CommonRoute  route="common"   path={"/RandomPin"} component={RandomPin} />
           <Route      path={"/CreateNewPassword"} component={CreateNewPassword} />
           <CommonRoute  route="common"   path={"/Settings"} component={Settings} />
           <CommonRoute  route="admin"   path={"/EditPaymentRules"} component={EditPaymentRules} />
           <CommonRoute  route="patient"   path={"/Paymentpage"} component={Paymentpage} />
           <CommonRoute  route="patient"   path={"/EnableAccount"} component={EnableAccount} />

           <Route  component={PageNotFound} />
            
        </Switch>
      </BrowserRouter>
    );
  }
}

export default EpaparRoad
